<template>
  <div class="modal fade" :id="'kt_modal_' + id" data-backdrop="static" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <form @submit.prevent="storeAnswerChoices" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('qvct_survey.answerChoice.creation') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">

              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>

          <div class="modal-body">
            <RequiredText />

            <Select2
                containerClass="col-12 mt-auto mb-5"
                :name="`${id}-answer-type`"
                :multiple="false"
                :parent-id="'#kt_modal_' + id"
                :label="$t('qvct_survey.answerType.name')"
                labelClass="form-label fs-6 text-black"
                :selectClass="'form-select form-control-sm form-select-solid'"
                :isRequired="true"
                v-model="formData.answer_type_id"
                :IsInputGroup ="true"
                icon="bi bi-plus"
                :clickAddon="openCreateAnswerChoiceModal"
            >
              <option v-for="type in answerTypes" :key="type.id" :value="type.id">
                {{ type.name }}
              </option>
            </Select2>

            <div v-for="(choice, index) in formData.choices" :key="index" class="border rounded p-3 mb-5 position-relative">
              <div class="card-body row g-3">

                <Input
                    containerClass="col-12 mt-auto mb-5"
                    :name="`${id}-choice-label-${index}`"
                    type="text"
                    :label="$t('qvct_survey.answerChoice.label')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    :isRequired="true" size="lg"
                    :placeholder="$t('qvct_survey.answerChoice.label_placeholder')"
                    v-model="choice.label"
                />

                <Input
                    containerClass="col-6 mt-auto mb-5"
                    :name="`${id}-choice-percentage-${index}`"
                    type="number"
                    :label="$t('qvct_survey.answerChoice.percentage')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    :isRequired="true" size="lg"
                    v-model.number="choice.percentage"
                    :min="0"
                    :max="100"
                />

                <Input
                    containerClass="col-6 mt-auto mb-5"
                    :name="`${id}-choice-order-${index}`"
                    type="number"
                    :label="$t('qvct_survey.answerChoice.order')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    :isRequired="false"
                    :placeholder="$t('qvct_survey.answerChoice.order_placeholder')"
                    v-model.number="choice.order"
                />


                <div class="d-flex align-items-end justify-content-end">
                  <Button btn-class="btn-sm me-3" type="new" background-color="red"  iconClass="fa fa-trash" @click.prevent="removeChoice(index)"  />
                </div>
              </div>
            </div>

            <CreateQvctAnswerType
                id="create_qvct_answer_type"
                @reload="reload"
            />

            <Button  btn-class="btn-sm me-3" type="new"  btn-text="label.addAnswerChoice"  @click.prevent="addChoice"/>
          </div>

          <div class="modal-footer">
            <Button btn-class="btn-sm me-2" type="cancel" btn-text="button.close" @click="closeModal"/>
            <Button btn-class="btn-sm" type="submit" btn-text="button.save" :isLoading="processing"/>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>


<script setup>
import {ref, defineProps, onMounted, computed} from "vue";
import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText.vue"
import Button from "@/components/Button.vue"
import "vue3-colorpicker/style.css";
import CreateQvctAnswerType from "@/Modules/Qvct/components/CreateQvctAnswerType.vue";

const props = defineProps({
  id: { type: String, required: true },
});

const store = useStore();
const processing = ref(false);

const formData = ref({
  answer_type_id: "",
  choices: [
    { label: "", percentage: 0, order: null }
  ]
});


const answerTypes = computed(() => store.getters['qvctAnswersType/getQvctAnswersType']);
function addChoice() {
  formData.value.choices.push({ label: "", percentage: 0, order: null });
}

function removeChoice(index) {
  formData.value.choices.splice(index, 1);
}

function openCreateAnswerChoiceModal(){
  $('#kt_modal_create_qvct_answer_type').modal('toggle')
}
function closeModal() {
  $("#kt_modal_" + props.id).modal('hide');
}

function reload(answerType){
  loadData();
  formData.value.answer_type_id = answerType;
}

function storeAnswerChoices() {
  processing.value = true;
  store.dispatch('qvctAnswersChoise/storeQvctAnswerChoice', formData.value)
      .then(() => {
        window.toastr['success'](i18n.global.t("notification.answerChoice_created"));
        closeModal();
      })
      .finally(() => processing.value = false);
}

function loadData() {
  Promise.all([
    store.dispatch('qvctAnswersType/loadQvctAnswerType'),
  ])
}

onMounted(() => {
  loadData()
});
</script>
